import { render } from "./TwoFactorChallengeForm.vue?vue&type=template&id=a7bb1fca"
import script from "./TwoFactorChallengeForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorChallengeForm.vue?vue&type=script&lang=js"
script.render = render

export default script